

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LabCultureHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface LabCultureHeader {
    id?: number;
    headerValue: string;
    isActive:string;
    tenantId?: any;
    branchId?: any;  
    
    
  parameters?: LabCultureHeaderParameter[];
  links?: any;
}

export abstract class LabCultureHeaderData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<LabCultureHeader[]>;
  abstract create(url: string, data: LabCultureHeader): Observable<LabCultureHeader[]>;
  abstract update(url: string, data: LabCultureHeader): Observable<LabCultureHeader>;
  abstract delete(url: string): Observable<any>;
}